import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import CButton from '@/components/CButton'
import {connect} from 'react-redux'
import { setStorage,getStorage} from "@/utils";
import './index.scss'
import {Menu, Card, Modal, Button, message, Empty} from "antd";
import {bindActionCreators, compose} from "redux";
import { withRouter} from 'react-router-dom'
import {
    collapsedToggle,
    setWindowInfo,
    setUserInfo,
    setCurrentTheme,
    setUserList,
    setLbname, setMenu
} from "../../redux/common/action";
import { loginout,selectIndex } from "@/servers/commonApi";
import {clearboth} from "../../utils/clear";
import ReactApexChart from "react-apexcharts";

@CBaseComponent
class Home extends Component{
    constructor(props) {
        super(props);
        this.handleCanceldialog=this.handleCanceldialog.bind(this)
        this.selectdata = this.selectdata.bind(this)
        this.menuClick = this.menuClick.bind(this)
    }


    state = {
        loading: false,
        fileslist:[],
        newslist:[],
        content:'',
        result:{},
        series: [],
        statgraph:{
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            dataLabels: {
                formatter: (val) => {
                    return val
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false
                }
            },
            title: {
                text: '按性质分级统计'
            },
            xaxis: {
                categories: [
                    '全部',
                    '文物系统国有博物馆',
                    '其他行业国有博物馆',
                    '非国有博物馆'
                ]
            },
            fill: {
                opacity: 1
            },
            colors: ['#80c7fd', '#008FFB', '#80f1cb', '#00E396', '#ffe7ba', '#ffd591'],
            yaxis: {
                labels: {
                    formatter: (val) => {
                        return val
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left'
            }
        },
        series2: [],
        statgraph2:{
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            dataLabels: {
                formatter: (val) => {
                    return val
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false
                }
            },
            title: {
                text: '按题材类型分级统计'
            },
            xaxis: {
                categories: [
                    '全部',
                    '综合地志',
                    '历史文化',
                    '革命纪念',
                    '自然科技',
                    '考古遗址',
                    '艺术',
                    '其他'
                ]
            },
            fill: {
                opacity: 1
            },
            colors: ['#80c7fd', '#008FFB', '#80f1cb', '#00E396', '#ffe7ba', '#ffd591'],
            yaxis: {
                labels: {
                    formatter: (val) => {
                        return val
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left'
            }
        },
        series3: [],
        statgraph3:{
            series: [
                {
                name: '申报一级',
                data: [10,4,21,17,13,11,6,16,13,25,27,17,20,27,45,31,15,19,32,9,0,8,19,3,8,1,16,12,2,4,3,1]
            }, {
                name: '申报二级',
                data: [5,0,9,8,11,3,4,12,4,16,18,10,10,11,32,15,17,8,21,9,0,6,12,2,6,0,11,10,1,2,4,0]
            }, {
                name: '申报三级',
                data: [13,6,13,16,14,9,9,16,9,26,35,19,9,12,50,31,17,13,28,9,3,9,32,13,14,1,28,19,3,6,9,1]
            }],
            chart: {
                type: 'bar',
                height: 550,
                stacked: true,
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    dataLabels: {
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    }
                },
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            title: {
                text: '分省分级统计'
            },
            xaxis: {
                categories: ['北京','天津','河北','山西','内蒙古','辽宁','吉林','黑龙江','上海','江苏','浙江','安徽','福建','江西','山东','河南','湖北','湖南','广东','广西','海南','重庆','四川','贵州','云南','西藏','陕西','甘肃','青海','宁夏','新疆','新疆生产建设兵团'],
                labels: {
                    formatter: function (val) {
                        return val
                    }
                }
            },
            yaxis: {
                title: {
                    text: undefined
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val
                    }
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: 'top',
                horizontalAlign: 'left',
                offsetX: 10
            }
        }

    };

    showModal = (data) => {
        this.setState({
            isModalVisible:true
        })
        var newStr = decodeURI(data.content).replaceAll("++++","\n");
        this.setState({
            title:data.title,
            name: data.postedby,
            time:data.postedtime,
            content:newStr
        })
    };

    handleCancel = () => {
        this.setState({
            isModalVisible:false
        })
    };


    menuClick(){
        const userInfo = getStorage('userList')
        const result =  this.changeitem(userInfo.menulist)
        result.splice(1,1)
        setStorage('menu', result);
        this.props.setMenu(result);
        this.props.history.push({
            pathname: '/personinfo',
        });
    }

    changeitem(data){
        data.forEach(item=>{
            item.showids = item.id
            if (item.children){
                this.changeitem(item.children)
            }
        })
        return data
    }


    handleCanceldialog(){
        this.setState({
            title: '',
            content:'',
            isModalVisible: false
        })
    }

    componentWillReceiveProps(nextProps){

    }

    componentWillMount(){
    }

    selectdata(){
        selectIndex().then(res=>{
            console.log(res.records[0].graph1);
            if (res.statecode === 0) {
                this.setState({
                    result:res.records[0],
                    fileslist:res.records[0].filelist,
                    newslist:res.records[0].bulletinlist,
                    loading:false,
                })
                if (res.records[0].graph1){
                    this.setState({
                        statgraph:{...this.state.statgraph,xaxis:res.records[0].graph1.xaxis,
                            colors:res.records[0].graph1.colors,},
                        series:res.records[0].graph1.series,
                    })
                }
                if (res.records[0].graph2){
                    this.setState({
                        statgraph2:{...this.state.statgraph2,xaxis:res.records[0].graph2.xaxis,
                            colors:res.records[0].graph2.colors,},
                        series2:res.records[0].graph2.series,
                    })
                }
                if (res.records[0].graph3){
                    this.setState({
                        statgraph3:{...this.state.statgraph3,xaxis:res.records[0].graph3.xaxis,
                            colors:res.records[0].graph3.colors,},
                        series3:res.records[0].graph3.series,
                    })
                }
            } else {
                message.error(res.statemessage);
            }
        })
    }


    componentDidMount(){
        this.selectdata()
    }

    render(){
        return (
            <main style={{textAlign:'left'}} className='containerblock'>
                <div className='contents'>
                    <div className='zhibiao'>
                        <span>当前进展：{this.state.result.step}</span>
                    </div>
                    {JSON.stringify(this.state.result) !== '{}' && <div id="chart">
                        <div style={{display:'flex'}}>
                            <div style={{width:"50%"}}>
                                <ReactApexChart options={this.state.statgraph} series={this.state.series} type="bar"  height={450}/>
                            </div>
                            <div style={{width:"50%"}}>
                                <ReactApexChart options={this.state.statgraph2} series={this.state.series2} type="bar"  height={450}/>
                            </div>
                        </div>
                        <div>
                            <ReactApexChart options={this.state.statgraph3} series={this.state.series3} type="bar"  height={800}/>
                        </div>
                    </div>
                    }
                    <div className='system-info'>
                        <div className='system-tz'>
                            <Card title="系统公告" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.newslist.length === 0? <Empty></Empty>:
                                        this.state.newslist.map(item=>{
                                            return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                                                {
                                                    Number(item.top > 1000) ?
                                                        <span className='important'>{item.title}</span>:
                                                        <span>{item.title}</span>
                                                }
                                                <span>{item.postedtime}</span>
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                        <div className='system-file'>
                            <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.fileslist.length === 0? <Empty></Empty>:
                                        this.state.fileslist.map(item=>{
                                            return <div onClick={()=>{this.downloads(item)}} className='new-block'>
                                                <a href={item.fileurl} style={{color:'rgb(60, 185, 241)'}}>{item.title}</a >
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                    </div>
                    </div>
                <Modal title={this.state.title}
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
                    <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
                </Modal>
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        breadcrumbData: state.breadcrumbData,
        collapsed: state.collapsed,  // 侧边栏是否展开
        windowInfo: state.windowInfo,
        userInfo: state.userInfo,
        userList: state.userList,
        setLbname:state.setLbname
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        collapsedToggle: bindActionCreators(collapsedToggle, dispatch),
        setWindowInfo: bindActionCreators(setWindowInfo, dispatch),
        setUserInfo: bindActionCreators(setUserInfo, dispatch),
        setCurrentTheme: bindActionCreators(setCurrentTheme, dispatch),
        setUserList:bindActionCreators(setUserList,dispatch),
        setLbname:bindActionCreators(setLbname,dispatch),
        setMenu:bindActionCreators(setMenu,dispatch),
    };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Home);
